<template>
  <div class="action-dispatcher">
    <slot v-if="alwaysShowSlot" v-bind:data="data" />

    <template v-if="loading">
      <div
        v-if="small"
        class="d-flex justify-content-center align-items-center"
      >
        <b-spinner variant="danger" small />
      </div>
      <div
        v-else
        class="d-flex justify-content-center p-5"
        :class="loadingClass"
      >
        <b-spinner variant="danger" style="width: 3rem; height: 3rem;" />
      </div>
    </template>

    <div v-else-if="error" class="error p-4 text-center">
      Erro!
      <button class="btn-link link" @click="dispatch">
        Tentar novamente
      </button>
    </div>

    <slot v-else-if="!alwaysShowSlot" v-bind:data="data" />
  </div>
</template>

<script>
export default {
  props: {
    action: String,
    parameters: [Object, Number, String],
    loadingClass: String,
    small: Boolean,
    alwaysShowSlot: Boolean
  },
  data() {
    return {
      loading: true,
      error: false,
      data: null
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch(this.action, this.parameters)
        .then(data => {
          this.error = false;
          this.data = data;
          this.$emit("success", data);
        })
        .catch(error => {
          this.error = true;
          this.$emit("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.action-dispatcher {
  .error {
    .link {
      padding: 0;
      border: none;
      background: transparent;
    }
  }
}
</style>
